import { SemanticCOLORS } from 'semantic-ui-react';
import { IMPORT_DESCRIPTOR_TYPE } from '../../../../../../constants/generalConstants';
import { ImportDescriptorDataTypeType } from '../../../../../../types';

export function getScaleLabelColor(
    generalScale: number,
    descriptorScale: number,
    descriptorDataType: ImportDescriptorDataTypeType
): SemanticCOLORS {
    return descriptorDataType === IMPORT_DESCRIPTOR_TYPE.NUMBER && generalScale !== descriptorScale ? 'yellow' : 'grey';
}

type GetSelectScaleStylingReturnType = {
    classes: string;
};
export function getSelectScaleStyling(
    generalScale: number,
    descriptorScale: number,
    descriptorDataType: ImportDescriptorDataTypeType
): GetSelectScaleStylingReturnType {
    let classes = 'select select__scales';

    if (generalScale !== descriptorScale && descriptorDataType === IMPORT_DESCRIPTOR_TYPE.NUMBER) {
        classes = `${classes} bg-yellow`;
    } else {
        classes = `${classes} bg-grey`;
    }

    return { classes };
}
